export const foilColorToHex = (foilColor: string): string => {
  switch (foilColor) {
    case 'copper':
      return 'ab7440';
    case 'silver':
      return 'aaa9ad';
    case 'gold':
      return 'd4af37';
    default:
      return '';
  }
};
